import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getAreaList = (params, options) =>
  request.get(
    '/api/blade-system/region/lazy-tree',
    Object.assign({}, options, { params })
  );

  export const serviceItemPage = (params, options) =>
  request.get(
    '/api/nursing/serviceItem/page',
    Object.assign({}, options, { params })
  );

  export const serviceItemDetail = (params, options) =>
  request.get(
    '/api/nursing/serviceItem/detail',
    Object.assign({}, options, { params })
  );
  export const serviceItemSave= (params, options) =>
  request.post('/api/nursing/serviceItem/save', params, options);


  export const serviceItemUpdate= (params, options) =>
  request.post('/api/nursing/serviceItem/update', params, options);

  export const serviceItemRemove= (id) =>
  request.post('/api/nursing/serviceItem/remove?ids='+id);

  //明细查询
  export const serviceItemList = (params, options) =>
  request.get(
    '/api/nursing/serviceItemList/page',
    Object.assign({}, options, { params })
  );
//明细新增
export const serviceItemListSave= (params, options) =>
request.post('/api/nursing/serviceItemList/save', params, options);

//明细查询
export const serviceItemListDetail = (params, options) =>
request.get(
  '/api/nursing/serviceItemList/detail',
  Object.assign({}, options, { params })
);
//明细修改
export const serviceItemListUpdate= (params, options) =>
request.post('/api/nursing/serviceItemList/update', params, options);

export const serviceItemListRemove= (id) =>
request.post('/api/nursing/serviceItemList/remove?ids='+id);
  export const nursingDetail = (params, options) =>
  request.get(
    '/api/nursing/detail',
    Object.assign({}, options, { params })
  );
//明细修改
export const stockWarnSave= (params, options) =>
request.post('/api/nursing/registration/save', params, options);

//明细修改
export const stockWarnUpdate= (params, options) =>
request.post('/api/nursing/registration/update', params, options);

//明细修改
export const stockWarnDelete= (id) =>
request.post('/api/nursing/registration/remove?ids='+id);

//明细查询
export const getNursinghome = (params, options) =>
request.get(
  '/api/nursing/getNursinghome',
  Object.assign({}, options, { params })
);

//明细查询
export const getNursinghomePage = (params, options) =>
request.get(
  '/api/nursing/basicInfor/page',
  Object.assign({}, options, { params })
);

//明细修改
export const saveBasicInfo= (params, options) =>
request.post('/api/nursing/basicInfor/submit', params, options);

//明细修改
export const saveFamilyMember= (params, options) =>
request.post('/api/nursing/familyMember/submit', params, options);

//明细查询
export const getFamilyMemberPage = (params, options) =>
request.get(
  '/api/nursing/familyMember/page',
  Object.assign({}, options, { params })
);

//明细修改
export const saveHealthInfo= (params, options) =>
request.post('/api/nursing/health/submit', params, options);

//明细修改
export const saveMedicalTestInfo= (params, options) =>
request.post('/api/nursing/physical/submit', params, options);

//明细修改
export const saveCateringBedInfo= (params, options) =>
request.post('/api/nursing/cateringBed/submitBatch', params, options);

//明细修改
export const basicInforRemove= (id) =>
request.post('/api/nursing/basicInfor/remove?ids='+id);

//明细查询
export const getHealthPageDetail = (params, options) =>
request.get(
  '/api/nursing/health/detail',
  Object.assign({}, options, { params })
);

//明细查询
export const getPhysicalDetail = (params, options) =>
request.get(
  '/api/nursing/physical/detail',
  Object.assign({}, options, { params })
);

//明细查询
export const getCateringBedDetail = (params, options) =>
request.get(
  '/api/nursing/cateringBed/getFeeStandards',
  Object.assign({}, options, { params })
);

//明细修改
export const familyMemberRemove= (id) =>
request.post('/api/nursing/familyMember/remove?ids='+id);

//明细查询
export const getBedTypeList = (params, options) =>
request.get(
  '/api/nursing/bed/type/list',
  Object.assign({}, options, { params })
);

//明细查询
export const getDeviceTypePage = (params, options) =>
request.get(
  '/api/nursing/deviceType/page',
  Object.assign({}, options, { params })
);


//明细修改
export const saveDeviceType= (params, options) =>
request.post('/api/nursing/deviceType/save', params, options);

//明细修改
export const deviceTypeRemove= (id) =>
request.post('/api/nursing/deviceType/remove?ids='+id);

//明细查询
export const getDeviceModelList = (params, options) =>
request.get(
  '/api/nursing/deviceModel/modellist',
  Object.assign({}, options, { params })
);

//明细查询
export const getDeviceModelPage = (params, options) =>
request.get(
  '/api/nursing/deviceModel/page',
  Object.assign({}, options, { params })
);

//明细查询
export const getDeviceTypeList = (params, options) =>
request.get(
  '/api/nursing/deviceType/typelist',
  Object.assign({}, options, { params })
);

//明细查询
export const getPartnerList = (params, options) =>
request.get(
  '/api/nursing/partner/partnerlist',
  Object.assign({}, options, { params })
);

//明细修改
export const saveDeviceModel= (params, options) =>
request.post('/api/nursing/deviceModel/save', params, options);

//明细修改
export const deviceModelRemove= (id) =>
request.post('/api/nursing/deviceModel/remove?ids='+id);

//明细查询
export const getWristbandPage = (params, options) =>
request.get(
  '/api/nursing/wristband/page',
  Object.assign({}, options, { params })
);

//明细查询
export const getNursingList = (params, options) =>
request.get(
  '/api/nursing/basicInfor/nursinglist',
  Object.assign({}, options, { params })
);

//明细修改
export const saveWristband= (params, options) =>
request.post('/api/nursing/wristband/save', params, options);

//明细修改
export const wristbandRemove= (id) =>
request.post('/api/nursing/wristband/remove?ids='+id);

//明细查询
export const getEventsPage = (params, options) =>
request.get(
  '/api/nursing/events/page',
  Object.assign({}, options, { params })
);

//明细修改
export const saveEvents= (params, options) =>
request.post('/api/nursing/events/save', params, options);

//明细修改
export const updateEvents= (params, options) =>
request.post('/api/nursing/events/update', params, options);

//明细修改
export const eventsRemove= (id) =>
request.post('/api/nursing/events/remove?ids='+id);

//明细查询
export const getEventsDetail = (params, options) =>
request.get(
  '/api/nursing/events/detail',
  Object.assign({}, options, { params })
);

//明细查询
export const getBasicInforDetail = (params, options) =>
request.get(
  '/api/nursing/basicInfor/detail',
  Object.assign({}, options, { params })
);

//明细修改
export const updateDeviceType= (params, options) =>
request.post('/api/nursing/deviceType/update', params, options);


//明细修改
export const updateDeviceModel= (params, options) =>
request.post('/api/nursing/deviceModel/update', params, options);

//明细修改
export const updateWristband= (params, options) =>
request.post('/api/nursing/wristband/update', params, options);

//明细查询
export const deviceStart = (params, options) =>
request.get(
  '/api/nursing/wristband/start',
  Object.assign({}, options, { params })
);

//明细查询
export const deviceStop = (params, options) =>
request.get(
  '/api/nursing/wristband/stop',
  Object.assign({}, options, { params })
);

//明细查询
export const treeNursingList = (params, options) =>
request.get(
  '/api/nursing/common/tree-Nursing-list',
  Object.assign({}, options, { params })
);

// 加载全部树-床位
export const treeNursingAll= (params, options) =>
request.get(
  '/api/nursing/common/tree-Nursing-tree',
  Object.assign({}, options, { params })
);

//明细查询
export const treeListDetail = (params, options) =>
request.get(
  '/api/nursing/bed/detail',
  Object.assign({}, options, { params })
);


//明细查询
export const healthPage = (params, options) =>
request.get(
  '/api/v4ward/wristband/health/page',
  Object.assign({}, options, { params })
);

//明细查询
export const healthBasicInfo = (params, options) =>
request.get(
  '/api/v4ward/wristband/health/basicInfo',
  Object.assign({}, options, { params })
);


//获取养老院下用户的数据（姓名+手机号）
export const getUserPhoneList = (params, options) =>
request.get(
  '/api/nursing/basicInfor/getUserPhoneList',
  Object.assign({}, options, { params })
);

//签约
export const saveSign= (params, options) =>
request.post('/api/nursing/contract/signContract', params, options);

//续约
export const saveRenew= (params, options) =>
request.post('/api/nursing/contract/extendContract', params, options);

//入住
export const saveMove= (params, options) =>
request.post('/api/nursing/basicInfor/checkIn', params, options);

//退约
export const saveRefund= (params, options) =>
request.post('/api/nursing/contract/existContract', params, options);

//编辑合同信息
export const contractupdate= (params, options) =>
request.post('/api/nursing/contract/update', params, options);

//查询合同信息列表
export const contractList = (params, options) =>
request.get(
  '/api/nursing/contract/page',
  Object.assign({}, options, { params })
);

//查询合同列表详情
export const contractDetail = (params, options) =>
request.get(
  '/api/nursing/contract/detail',
  Object.assign({}, options, { params })
);

//查询月单价
export const monthlyUnitPrice = (params, options) =>
request.get(
  '/api/nursing/contract/monthlyUnitPrice',
  Object.assign({}, options, { params })
);

